'use client'
import { useEffect, useRef, useState } from 'react'
// @ts-ignore
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/react-splide/css/core'
import { ImageWithFallback } from '@/components/atoms/ImageWithFallback'
import { ProductImage } from '@/interfaces/pages'
import './styles.scss'
export interface ProductGalleryProps {
  products: ProductImage[]
  isNew?: boolean
}

export const ProductGallery = ({ products, isNew }: ProductGalleryProps) => {
  const [index, setIndex] = useState(0)
  const productGalleryImage = useRef(null)
  const zoomImage = useRef(null)
  useEffect(() => {
    const handleMouseMove = (clientX: number, clientY: number) => {
      if (productGalleryImage.current && zoomImage.current) {
        const element = productGalleryImage.current as HTMLElement
        const imageElemet = zoomImage.current as HTMLElement
        const rect = element.getBoundingClientRect()
        let x = ((clientX - rect.left) / rect.width) * 100
        let y = ((clientY - rect.top) / rect.height) * 100
        if (y < 0) y = 0
        if (x < 0) x = 0
        if (y > 100) y = 100
        if (x > 100) x = 100
        imageElemet.style.top = `${y}%`
        imageElemet.style.left = `${x}%`
        imageElemet.style.transform = `translate(-${x}%, -${y}%)`
      }
    }

    const mouseEvent = (event: MouseEvent) =>
      handleMouseMove(event.clientX, event.clientY)

    const touchEvent = (event: TouchEvent) => {
      event.preventDefault()
      if (zoomImage.current) {
        const imageElemet = zoomImage.current as HTMLElement
        imageElemet.style.opacity = '1'
      }
      const touch = event.touches[0]
      handleMouseMove(touch.clientX, touch.clientY)
    }

    const touchEndEvent = () => {
      if (zoomImage.current) {
        const imageElemet = zoomImage.current as HTMLElement
        imageElemet.style.opacity = '0'
      }
    }
    let pdtImageRef: HTMLElement
    if (productGalleryImage.current) {
      pdtImageRef = productGalleryImage.current as HTMLElement
      pdtImageRef.addEventListener('mousemove', mouseEvent)
      pdtImageRef.addEventListener('touchmove', touchEvent)
      pdtImageRef.addEventListener('touchstart', touchEvent)
      pdtImageRef.addEventListener('touchend', touchEndEvent)
    }

    return () => {
      if (pdtImageRef) {
        pdtImageRef.removeEventListener('mousemove', mouseEvent)
        pdtImageRef.removeEventListener('touchmove', touchEvent)
        pdtImageRef.removeEventListener('touchstart', touchEvent)
        pdtImageRef.removeEventListener('touchend', touchEndEvent)
      }
    }
  }, [])

  return (
    <div className="product-gallery">
      <div
        ref={productGalleryImage}
        className={`product-gallery-active-image ${isNew ? 'badge-product-new' : 'badge-product-used'}`}
        id="product-gallery-active-image"
      >
        <ImageWithFallback
          className="normal-image"
          src={products[index].url}
          alt={products[index].alternativeText}
          width={products[index].width}
          height={products[index].height}
          priority
          fetchPriority="high"
        />
        <ImageWithFallback
          ref={zoomImage}
          id="image-zoom"
          className="image-zoom"
          role="presentation"
          alt=""
          width={products[index].width}
          height={products[index].height}
          src={products[index].url}
          quality={100}
          priority
        />
      </div>
      <Splide
        aria-label="Product Gallery"
        options={{
          arrows: true,
          pagination: false,
          perPage: 4,
          gap: '1rem',
          speed: 100,
          breakpoints: {
            768: {
              perPage: 3,
            },
          },
          lazyLoad: 'nearby',
          preloadPages: 1,
        }}
        hasTrack={false}
      >
        <SplideTrack>
          {products.map((product, idx) => (
            <SplideSlide
              key={product.id}
              onClick={() => {
                setIndex(idx)
              }}
            >
              <div className="product-container">
                <ImageWithFallback
                  src={product.url}
                  alt={product.alternativeText}
                  width={product.width}
                  height={product.height}
                  data-splide-lazy={product.url}
                  quality={100}
                  priority={idx === 0}
                />
              </div>
            </SplideSlide>
          ))}
        </SplideTrack>
      </Splide>
    </div>
  )
}
